export interface RetryStatus {
    readonly iterNumber: number
    readonly previousDelay: number | undefined
}

export const startStatus: RetryStatus = {
    iterNumber: 0,
    previousDelay: undefined,
}

export interface RetryPolicy {
    (status: RetryStatus): number | undefined
}

export const constantDelay =
    (delay: number): RetryPolicy =>
    () =>
        delay

export const limitRetries =
    (i: number): RetryPolicy =>
    (status) =>
        status.iterNumber >= i ? undefined : 0

export const exponentialBackoff =
    (delay: number): RetryPolicy =>
    (status) =>
        delay * Math.pow(2, status.iterNumber)

export const capDelay =
    (maxDelay: number) =>
    (policy: RetryPolicy): RetryPolicy =>
    (status) => {
        const delay = policy(status)
        return delay === undefined ? undefined : Math.min(maxDelay, delay)
    }

export const concat =
    (second: RetryPolicy) =>
    (first: RetryPolicy): RetryPolicy =>
    (status) => {
        const delay1 = first(status)
        const delay2 = second(status)
        if (delay1 !== undefined && delay2 !== undefined) {
            return Math.max(delay1, delay2)
        }
        return undefined
    }

export const applyPolicy =
    (policy: RetryPolicy) =>
    (status: RetryStatus): RetryStatus => ({
        iterNumber: status.iterNumber + 1,
        previousDelay: policy(status),
    })
